import React, {useState} from 'react';

import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import {Drawer, Fab} from '@mui/material';

interface Props {
  children: React.ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
  top?: number;
}

/**
 * 検索用サイドメニュー
 * @param props
 * @returns
 */
const LFCSideMenu = (props: Props) => {
  const [showSearchConditions, setShowSearchConditions] = useState(false);
  const toggleDrawer = (open: boolean) => (event: any) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setShowSearchConditions(open);
    open ? props.onOpen?.() : props.onClose?.();
  };

  return (
    <>
      <Fab
        sx={
          props.top !== undefined
            ? {position: 'fixed', top: props.top, right: 5}
            : {position: 'fixed', top: 65, right: 5}
        }
        color="primary"
        size="small"
        onClick={toggleDrawer(true)}
      >
        <ManageSearchIcon />
      </Fab>
      <Drawer anchor="right" open={showSearchConditions} onClose={toggleDrawer(false)}>
        {props.children}
      </Drawer>
    </>
  );
};
export default LFCSideMenu;
